import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8f3d4de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-callback-page page d-flex flex-column" }
const _hoisted_2 = { class: "page-content d-flex flex-grow-1" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_5 = {
  key: 1,
  class: "h-100 d-flex align-items-center justify-content-center"
}

import AppHeader from "@/components/Pages/AppHeader.vue";
import { useUserStore } from "@/store/user-store";
import { onMounted, reactive } from "vue";
import ModalDialog from "@/components/Modals/ModalDialog.vue";
import Loading from "../components/Pages/Loading.vue";
import { useRouter } from "vue-router";

interface LoginCallbackPageData {
	showLoading: boolean;
	showDialog: boolean;
	showRetryButton: boolean;
	modalTitle?: string;
	modalMessage?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginCallbackPage',
  setup(__props) {

const userStore = useUserStore();

let data = reactive<LoginCallbackPageData>({
	showLoading: true,
	showDialog: false,
	showRetryButton: false,
	modalTitle: undefined,
	modalMessage: undefined,
})

let router = useRouter();

function retry() {
	userStore.login();
}

onMounted(async () => {
	//Show progress dialog
	data.showDialog = true;
	data.showLoading = true;

	let result = await userStore.handleBrowserLoginCallback();
	//Show login successfull or failed and redirect to projects page

	data.showLoading = false;
	data.modalTitle = "Login";
	if (result) {
		data.modalMessage = "You have been successfully logged in";
		setTimeout(() => {
			router.replace({ path: "/" });
		}, 2000)
	} else {
		data.modalMessage = "Login failed. Please try again later.";
		data.showRetryButton = true;
	}
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppHeader, {
      "show-project": false,
      "show-survey": false
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ModalDialog, {
        visible: _unref(data).showDialog,
        title: _unref(data).modalTitle
      }, {
        default: _withCtx(() => [
          (_unref(data).modalMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createTextVNode(_toDisplayString(_unref(data).modalMessage) + " ", 1),
                (_unref(data).showRetryButton)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("button", {
                        class: "btn",
                        onClick: retry
                      }, "Retry")
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_unref(data).showLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(Loading)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["visible", "title"])
    ])
  ]))
}
}

})